var React = require('react');

function ArrowLink (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.00049 0.895437L0.895923 9L0.00048899 8.10456L8.10505 -7.08524e-07L9.00049 0.895437Z","fill":"#202020","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.69614 1.30435L0.000487945 1.30435L0.000487888 0L9.00049 -3.93402e-07L9.00049 9L7.69614 9L7.69614 1.30435Z","fill":"#202020","key":1})]);
}

ArrowLink.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none"};

module.exports = ArrowLink;

ArrowLink.default = ArrowLink;
